import { CONFIRMED_GET_FOLLOWUPS, CONFIRMED_CREATE_FOLLOWUP_ACTION } from "../actions/FollowUpType"

const initialState = {
  followUps: [],
  isLoading: false,
  error: null,
}

export default function FollowUpReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_FOLLOWUPS:
      return {
        ...state,
        followUps: action.payload,
        isLoading: false,
        error: null,
      }

    case CONFIRMED_CREATE_FOLLOWUP_ACTION:
      return {
        ...state,
        followUps: [...state.followUps, action.payload],
        isLoading: false,
        error: null,
      }

    default:
      return state
  }
}
